import { service } from "@ember/service";
import { task } from "ember-concurrency";
import ApplicationAdapter from "./application";

export default class ServerAdapter extends ApplicationAdapter {
  @service http;

  urlForCreateRecord(modelName, snapshot) {
    return `${this.apiBaseUri}/server/create?context=${snapshot.belongsTo("project").id}`;
  }

  urlForUpdateRecord(id, modelName, snapshot) {
    return `${this.apiBaseUri}/server/edit?serverid=${id}&context=${snapshot.belongsTo("project").id}`;
  }

  urlForDeleteRecord(id, modelName, snapshot) {
    let keepReservedIps = snapshot.adapterOptions?.keepReservedIps ?? true;

    return `${this.apiBaseUri}/server/destroy?serverid=${id}&keepip=${keepReservedIps}`;
  }

  async clone(server, data) {
    let { content } = await this.http.withContext(server.project.id).request({
      url: `${this.apiBaseUri}/server/clone`,
      method: "POST",
      body: { serverid: server.id, ...data },
    });

    return this.store.push(this.store.normalize("server", content.server));
  }

  console(server) {
    let url = `${this.apiBaseUri}/server/console?serverid=${server.id}`;

    return this.ajax(url, "GET").then((payload) => payload.response);
  }

  fetchStatusTask = task(async (server) => {
    let url = `${this.apiBaseUri}/server/status?serverid=${server.id}`;

    await this.ajax(url, "GET").then((payload) => {
      let data = payload.response;
      if (data) {
        try {
          this.store.push(this.store.normalize("server-status", { server: server.id, ...data.server }));
        } catch (e) {
          if (
            `${e.message}`.match(/Attempted to handle event `pushedData` on .* while in state root.deleted.inFlight./)
          ) {
            // The record may be `inFlight` when we try to push data. If that's the case
            // we will not be able to update the record.
            return;
          }
          throw e;
        }
      }
    });
  });

  fetchDetailsTask = task(async (server) => {
    let url = `${this.apiBaseUri}/server/details?serverid=${server.id}`;

    await this.ajax(url, "GET")
      .then((data) => {
        if (data) {
          try {
            this.store.push(this.store.normalize("server", data.response.server));
          } catch (e) {
            if (
              `${e.message}`.match(/Attempted to handle event `pushedData` on .* while in state root.deleted.inFlight./)
            ) {
              // The record may be `inFlight` when we try to push data. If that's the case
              // we will not be able to update the record.
              return;
            }
            throw e;
          }
        }
      })
      .catch((e) => {
        // Swallow the error if the server was just deleted.
        if (!server.get("isDeleted")) {
          throw e;
        }
      });
  });

  power(server, type) {
    let url = "";
    let data = {};

    switch (type) {
      case "on":
        url = `${this.apiBaseUri}/server/start`;
        data = { bios: false };
        break;
      case "on-bios":
        url = `${this.apiBaseUri}/server/start`;
        data = { bios: true };
        break;
      case "reboot":
        url = `${this.apiBaseUri}/server/stop`;
        data = { type: "reboot" };
        break;
      case "off":
        url = `${this.apiBaseUri}/server/stop`;
        data = { type: "soft" };
        break;
      case "off-forced":
        url = `${this.apiBaseUri}/server/stop`;
        data = { type: "hard" };
        break;
      case "reset":
        url = `${this.apiBaseUri}/server/reset`;
        break;
    }

    return this.ajax(url, "POST", {
      data: { serverid: server.id, ...data },
    });
  }

  async findBelongsTo(store, snapshot, url, relationship) {
    let payload = await super.findBelongsTo(...arguments);

    if (relationship.type !== "platform-argument") {
      return payload;
    }

    return { ...payload, id: snapshot.id };
  }
}
